import styled from 'styled-components';
import { Box } from '../../primitives/Box/Box.es.js';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { variant, themeMode, color, spacing, palette } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Group } from '../../primitives/Group/Group.es.js';

const StyledNavItem = styled(Group.Item)``;
const navLinkVariants = variant({
  prop: "variant",
  variants: {
    default: {
      ':not([aria-current="true"])': {
        color: themeMode({
          light: "neutral.500",
          dark: "neutral.400"
        })
      },
      fontWeight: "bold",
      "&:hover": {
        color: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        })
      },
      '&:active, &[aria-current="true"]': {
        color: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        })
      }
    },
    pill: {
      fontWeight: "bold",
      borderRadius: "round",
      color: themeMode({
        light: "neutral.900",
        dark: "neutral.50"
      }),
      backgroundColor: themeMode({
        light: "neutral.100",
        dark: "neutral.800"
      }),
      "&:hover": {
        color: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        }),
        backgroundColor: themeMode({
          light: "neutral.200",
          dark: "neutral.700"
        })
      },
      '&:active, &[aria-current="true"]': {
        color: themeMode({
          light: "neutral.50",
          dark: "neutral.900"
        }),
        backgroundColor: themeMode({
          light: "neutral.700",
          dark: "neutral.200"
        })
      }
    },
    tab: {
      position: "relative",
      color: themeMode({
        light: "neutral.500",
        dark: "neutral.400"
      }),
      fontWeight: "bold",
      "&:hover": {
        color: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        })
      },
      "&:focus-visible": {
        outline: 0,
        boxShadow: "none"
      },
      "&:after": {
        content: '" "',
        position: "absolute",
        top: "-3px",
        left: "-3px",
        width: "calc(100% + 6px)",
        height: "calc(100% + 6px)",
        opacity: 0,
        transition: "opacity 200ms ease-in",
        borderWidth: "2px",
        borderStyle: "solid",
        borderColor: `${color("border.base")}`,
        borderRadius: "lg"
      },
      "&:focus-visible:after": {
        opacity: 1
      },
      '&:active, &[aria-current="true"]': {
        color: themeMode({
          light: "neutral.900",
          dark: "neutral.50"
        }),
        "&:before": {
          content: '""',
          position: "absolute",
          width: "100%",
          height: "3px",
          bottom: "-1px",
          left: 0,
          backgroundColor: themeMode({
            light: "neutral.900",
            dark: "neutral.50"
          })
        }
      }
    }
  }
});
const navLinkSizes = variant({
  prop: "size",
  variants: {
    sm: {
      fontSize: "sm",
      lineHeight: "16px",
      py: "xxs",
      px: "xs"
    },
    md: {
      fontSize: "md",
      lineHeight: "20px",
      py: "xs",
      px: "sm"
    },
    lg: {
      fontSize: "lg",
      lineHeight: "24px",
      py: "sm",
      px: "md"
    }
  }
});
const navLinkSizesMobile = variant({
  prop: "size",
  variants: {
    md: {
      px: "md"
    }
  }
});
const getBadgePadding = (size) => {
  switch (size) {
    case "lg":
      return spacing("sm");
    case "md":
      return spacing("xs");
    case "sm":
      return spacing("xxs");
    default:
      return void 0;
  }
};
const NavLink = styled(Box)`
    display: flex;
    align-items: center;
    text-decoration: none;
    cursor: pointer;
    white-space: nowrap;

    ${navLinkVariants};
    ${navLinkSizes};
    padding-right: ${({ hasBadge, size }) => {
  if (hasBadge) {
    return getBadgePadding(size);
  }
  return void 0;
}};

    /**
     * This is a temporary fix for mobile to mimic the List.Item component.
     * The best would be to know if the menu is vertical and then change the styling of each element
     * TODO: [DS-534] Handle vertical styling based on the isVertical prop
     */
    ${({ theme }) => theme.breakpoint("md")`
       ${navLinkSizesMobile};
       min-height: 48px;
    `}
`;
const navStyles = variant({
  prop: "variant",
  variants: {
    tab: {
      borderBottomWidth: "1px",
      borderBottomStyle: "solid",
      borderBottomColor: themeMode({
        light: palette("neutral.300"),
        dark: palette("neutral.600")
      })
    }
  }
});
const Styled = {
  NavLink
};

export { Styled, StyledNavItem, navStyles };
//# sourceMappingURL=styled.es.js.map
